import { Component } from '@angular/core';

@Component({
  selector: 'app-create-part',
  template: ``,
  styleUrls: []
})
export class CreatePartComponent {

}
